// extracted by mini-css-extract-plugin
export default {"listings":"Listings_listings__MbPzK","cards":"Listings_cards__0CVDQ","card":"Listings_card__2RtAA","errorText":"Listings_errorText__7mN2a"};